module.exports = __webpack_public_path__ + "media/app_search/FreeTrialExtend/images/clients/client-icon-python-3b84eb4026f0c704e7e3d16972bb0e3d.svg";